<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <add-button @click="table_addItem">{{$I18n("add_setting")}}</add-button>
      <!-- 卡片主体(表格) -->
      <md-table v-model="tableData">
        <md-table-row slot="md-table-row" slot-scope="{ item }" >
          <md-table-cell :md-label="'ID'">{{ item.id }}</md-table-cell>
          <md-table-cell :md-label="$I18n('account_name')">{{ item.account_name }}</md-table-cell>
          <md-table-cell :md-label="$I18n('ad_unit_id')">{{ item.ad_unit_id }}</md-table-cell>
          <md-table-cell :md-label="$I18n('type')">{{ item.type_name }}</md-table-cell>
          <md-table-cell :md-label="$I18n('state')">{{ item.state_name }}</md-table-cell>
          <md-table-cell :md-label="$I18n('operate')"  class="button-box">
            <md-button
              @click.stop="table_editItem(item)"
              class="md-just-icon md-round md-info"
              ><md-icon>edit</md-icon></md-button
            >
            <md-button
              @click.stop="table_deleteItem(item)"
              class="md-just-icon md-round md-danger md-info left-icon"
              ><md-icon>close</md-icon></md-button
            >
          </md-table-cell>
        </md-table-row>
        <md-table-empty-state slot="md-table-empty-state">{{$I18n("none_data")}}</md-table-empty-state>
      </md-table>
      <!-- 翻页 -->
      <table-page :total="total" :pageSize="pageSize" v-model="pageNo"/>
    </div>
    <!-- 弹窗 -->
    <simple-modal 
      style="text-align: left;"
      ref="modal" 
      :title="modalTitle" 
      :right="openModalType!=='delete'" 
      @submit="modal_submit" 
      :large="openModalType==='import'" 
      :submitBtn="openModalType !=='import'"
    >
      <template slot="body">
        <!-- 删除弹窗 -->
        <div v-if="openModalType==='delete'">{{$I18n("check_delete", '')}}</div>
        <!-- 修改/添加弹窗 -->
        <div v-else class="md-layout">
          <common-form-item 
            v-for="item in form_modalData" 
            v-model="modalData.Form[item.keys]" 
            :error="modalData.Error[item.keys]" 
            :key="item.keys" v-bind="item"
          >
            <md-field v-if="item.keys === 'ad_limit_zone_list' " class="md-theme-default md-has-value" style="position: relative;">
              <md-input v-model="ad_limit_zone_list_name" />
              <div @click="$refs.ad_zone.open(modalData.Form.ad_limit_zone_list.split(','))" 
                style="position:absolute; top: 0; bottom: 0;left: 0; right: 0;z-index: 1;cursor: pointer;"></div>
            </md-field>
          </common-form-item>
        </div>
      </template>
    </simple-modal>
    <zone-select-mult-modal ref="ad_zone" @select="zone => (modalData.Form.ad_limit_zone_list = zone.join(','))"/>
  </div>
</template>
<script>
import { timestampToString1000, FormClass } from "@/common/tools.js";
import ZoneSelectMultModal from "@/components/Common/ZoneSelectMultModal.vue";
import {countryArray} from "@/common/continent.js";

export default {
  props: ["app_id"],
  components: {
    ZoneSelectMultModal
  },
  data() {
    return {
      total   : 0,
      pageSize: 10,
      pageNo  : 1,
      bindData: [],
      acc     : [],
      // 表格相关
      // 弹窗相关
      openModal     : false,  // 是否打开弹窗
      openModalType : "upload", // 弹窗类型
      modalTitle    : "",  // 弹窗标题
      // 弹窗表单相关
      ...({
        modalData : new FormClass({
          app_id    : "",
          account_id: "",
          ad_app_id : "",
          ad_app_key : "",
          ad_unit_id: {
            init: "",
            check:"required",
          },
          state     : 1,
          type      : 1,
          // ad_type: -1,
          ad_interval: {
            init: '360',
            check: (value) => {
              return isNaN(value) || parseInt(value) < 1;
            }
          },
          ad_limit_type: -1,

          ad_limit_zone_list: "",
        }),
      }),
      ad_limit_zone_list_name:"",
    };
  },
  mounted : function() {
    return this.api_getAdAcc()
      .then(this.api_getPageData)
      .then(() => {
        this.modalData.SetInit(this.app_id, "app_id");
        if(this.acc.length > 0){
          this.modalData.SetInit(this.acc[0].id, "account_id");
        }
      });
  },
  methods: {
    // 获取绑定
    api_getPageData(){
      return this.$api.getAdUnit({
        state     : 0,
        type      : 0,
        page_no   : this.pageNo,
        page_size : this.pageSize,
        app_id: this.app_id,
      })
        .then(this.$Then(res => {
          this.bindData = res.data;
          this.total = res.count;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.bindData = [];
          this.total = 0;
        }))
    },
    // 获取模板
    api_getAdAcc(){
      return this.$api.getAdAcc({
        type  : 0,
        state : 0,
        app_id: this.app_id,
      })
        .then(this.$Then(res => {
          this.acc = res.data;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.acc = [];
        }))
    },
    table_addItem(){
      if(this.acc.length === 0){
        this.$errorMsg(this.$I18n("none_plat_temp"));
        return
      }
      this.modalTitle = this.$I18n("add");
      this.modalData.Reset();
      this.openModalType = "add";
      this.$refs.modal.open();
    },
    table_editItem(item){
      this.modalTitle = this.$I18n("edit");
      this.modalData.Update({
        ...item,
        ad_limit_zone_list: item.ad_limit_zone ?JSON.parse(item.ad_limit_zone).join(",") :"",
      });
      this.openModalType = "edit";
      this.$refs.modal.open();
    },
    table_deleteItem(item){
      this.modalTitle = this.$I18n("delete");
      this.modalData.Update({...item});
      this.openModalType = "delete";
      this.$refs.modal.open();
    },
    // 隐藏 弹窗
    modal_classicModalHide () {
      this.$refs.modal.close();
    },
    // 提交表单
    modal_submit () {
      if(this.modalData.Check()){
        this.$errorMsg(this.$I18n("pls_check_verify"));
        return
      }
      let sendData = {
        ...this.modalData.Form,
        ad_limit_zone: JSON.stringify(this.modalData.Form.ad_limit_zone_list.split(",").filter(i => !!i)),
        app_id: this.app_id,
      }
      let apiPOST = new Promise(() => {});
      if(this.openModalType === "add"){
        apiPOST = this.$api.addAdUnit(sendData);
      } else if (this.openModalType === "edit"){
        apiPOST = this.$api.editAdUnit(sendData);
      } else if (this.openModalType === "delete"){
        apiPOST = this.$api.delAdUnit(sendData);
      }
      apiPOST
        .then(this.$Then(res => {
          if(res.code === 6001){
            this.$errorMsg(this.$I18n("pls_check_verify_3"));
            return
          }
          this.$successMsg(this.$I18n("succ_num"));
          this.modal_classicModalHide();
          this.api_getPageData();
        },[6001]))
        .catch(this.$Catch(this.$I18n("fail_num")))
    },
  },
  computed: {
    // 表格数据
    tableData(){
      if (!this.acc || this.acc.length === 0){
        return [];
      } else {
        return [...this.bindData]
          .map((item , index) => {
            let type_name = "";
            if(item.type == 1){
              type_name = this.$I18n("src_ads");
            } else if(item.type == 2){
              type_name = this.$I18n("ban_ads");
            } else if(item.type == 3){
              type_name = this.$I18n("rew_ads");
            }
            let state_name = "";
            if(item.state == 1){
              state_name = this.$I18n("open");
            } else if(item.state == 2){
              state_name = this.$I18n("closed");
            } 
            return {
              index,
              type_name,
              state_name,
              create_date : timestampToString1000(item.gmt_create),
              ... item,
            }
          })
      }
    },
    form_modalData(){
      return [
        {
          label   : this.$I18n("ad_account_id"),
          keys    : "account_id",
          type    : "select",
          options : this.acc.map(i => {
            return {
              id  : i.id,
              name: i.name,
            }
          }),
          required: true,
          class: "md-layout-item md-size-100",
        },{
          label   : this.$I18n("ad_app_id"),
          keys    : "ad_app_id",
          type    : "input",
          class   : "md-layout-item md-size-100",
        },{
          label   : this.$I18n("ad_app_key"),
          keys    : "ad_app_key",
          type    : "input",
          class   : "md-layout-item md-size-100",
        },{
          label   : this.$I18n("ad_unit_id"),
          keys    : "ad_unit_id",
          type    : "input",
          check   : true,
          required: true,
          class: "md-layout-item md-size-100",
        },{
          label   : this.$I18n("type"),
          keys    : "type",
          type    : "select",
          options : [
            // 1：开屏广告，2：横幅，3：激励广告
            {id: 1, name: this.$I18n("src_ads")},
            {id: 2, name: this.$I18n("ban_ads")},
            {id: 3, name: this.$I18n("rew_ads")},
          ],
          required: true,
          class: "md-layout-item md-size-100",
        },{
          label   : this.$I18n("state"),
          keys    : "state",
          type    : "select",
          options : [
            // 1：开屏广告，2：横幅，3：激励广告
            {id: 1, name: this.$I18n("open")},
            {id: 2, name: this.$I18n("closed")},
          ],
          required: true,
          class: "md-layout-item md-size-100",
        // },{
        //   label   : this.$I18n("ad_type"),
        //   keys    : "ad_type",
        //   type    : "select",
        //   options : [
        //     {id: -1, name: this.$I18n("none")},
        //     {id: 1, name: this.$I18n("topon")},
        //     {id: 2, name: this.$I18n("admob")},
        //   ],
        //   class   : "md-layout-item md-size-50",
        },{
          label   : this.$I18n("ad_int"),
          keys    : "ad_interval",
          type    : "input",
          check   : true,
          required: true,
          class   : "md-layout-item md-size-100",
        },{
          label   : this.$I18n("ad_rest_type"),
          keys    : "ad_limit_type",
          type    : "select",
          options : [
            {id: -1, name: this.$I18n("none")},
            {id: 1, name: this.$I18n("open_area")},
            {id: 2, name: this.$I18n("close_area")},
          ],
          class   : "md-layout-item md-size-100",
        },{
          label   : this.$I18n("ad_area_cont"),
          keys    : "ad_limit_zone_list",
          class   : "md-layout-item md-size-100",
        }
      ]
    },
  },
  watch:{
    'modalData.Form.ad_limit_zone_list':{
      handler(newValue){
        if(!newValue){
          this.ad_limit_zone_list_name = "";
          return
        }
        this.ad_limit_zone_list_name = newValue.split(",")
          .map(i => countryArray.filter(j => j.code === i)[0])
          .filter(i => !!i)
          .map(i => this.$router.history.current.query.lang === "zh" ?i.cn_name :i.name)
          .join(",")
        return 
      },
      immediate: true,
      deep: true,
    },
  },
}
</script>
<style lang="scss" scoped>
  .left-btn {
    text-align:left;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .left-table{
    margin-top: 16px;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-rigth:8px;
    padding-left:8px;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }

  // 表单里的单选框
  .radio-layout{
    margin-top: 6px;
  }
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 160px;
  }
  // 表格的按钮列
  .button-box {
    width: 120px;
  }
  //左侧iocn
  .left-icon{
    margin-left: 16px;
  }
  // flaot 右的按钮
  .right-button {
    float:right;
  }

  .text-right .md-table-cell-container {
    display: flex;
    justify-content: flex-end;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }

  .table-stats {
    display: flex;
    align-items: center;
    text-align: right;
    flex-flow: row wrap;

    .td-price .td-total {
      display: inline-flex;
      font-weight: 500;
      font-size: 1.0625rem;
      margin-right: 50px;
    }

    &.table-striped .td-price {
      border-bottom: 0;
    }

    .td-price {
      font-size: 26px;
      border-top: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
    }

    .td-price,
    > div {
      flex: 0 0 100%;
      padding: 12px 8px;
    }
  }
</style>